/**
 * 分组授权树：跨 Tab / 搜索过滤时合并勾选，避免只保留当前树可见项。
 */

/** 收集树中所有 perm:ID */
export function collectPermIdsInTree(nodes, out = new Set()) {
  (nodes || []).forEach((node) => {
    const key = String(node?.key || '');
    if (key.startsWith('perm:')) {
      const id = Number(key.slice(5));
      if (Number.isFinite(id)) out.add(id);
    }
    if (node?.children?.length) collectPermIdsInTree(node.children, out);
  });
  return out;
}

/**
 * @param {number[]} previousSelectedIds 当前已选（含其它 Tab）
 * @param {Array} activeTreeData 当前正在勾选的那棵树（可已过滤）
 * @param {Array|{checked?:string[]}} checkedKeysFromTree antd onCheck 返回值
 * @param {(keys:any)=>number[]} treeKeysToPermissionIds
 * @returns {number[]}
 */
export function mergeGroupPermissionSelection(
  previousSelectedIds,
  activeTreeData,
  checkedKeysFromTree,
  treeKeysToPermissionIds
) {
  const list = Array.isArray(checkedKeysFromTree)
    ? checkedKeysFromTree
    : (checkedKeysFromTree?.checked || []);
  const checkedInThisTree = (typeof treeKeysToPermissionIds === 'function'
    ? treeKeysToPermissionIds(list)
    : [])
    .map(Number)
    .filter((id) => Number.isFinite(id));

  const idsInActiveTree = collectPermIdsInTree(activeTreeData);
  const preserved = (previousSelectedIds || [])
    .map(Number)
    .filter((id) => Number.isFinite(id) && !idsInActiveTree.has(id));

  return Array.from(new Set([...preserved, ...checkedInThisTree]));
}
